import { connect } from 'react-redux';
import InfoEC from './InfoEC';
import accountActions from '../../../../../store/actions/account.action';

const mapStateToProps = state => ({
  isLoading: state.account.loading,
  unexpectedError: state.account.unexpectedError
});

const mapDispatchToProps = dispatch => {
  return {
    getAccounts: () => {
      dispatch(accountActions.getAccounts('SIGHT'));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoEC);
